//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from 'vuex';
import FormulaConfig from './formulaConfig.vue';
import conditionalSelectionTree from '../../components/conditionalSelectionTree.vue';
import { cloneDeep } from 'lodash';
import CreateCloudEventDiaVue from './createCloudEventDia.vue';
import CreateNotifyEventDiaVue from './createNotifyEventDia.vue';
import EventCascader from '@/components/eventCascader';

/* eslint-disable */
export default {
  name: '',
  components: {
    FormulaConfig,
    conditionalSelectionTree,
    CreateCloudEventDiaVue,
    CreateNotifyEventDiaVue,
    EventCascader,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    // 开始时间
    initialTriggerTime(selectTime) {
      const date = new Date(new Date(selectTime).setHours(0, 0, 0, 0)).getTime();
      const today = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
      if (date <= today) {
        // 当选择的日期就是当天的时候，这个时候就要限制时间应当大于此时此刻的时分秒
        this.pickerOptions.selectableRange =
          new Date().getHours() + ':' + (new Date().getMinutes() + 1) + ':00' + '- 23:59:59';
      } else {
        // 当选择的日期大于当天的时候，这时需要把时分秒的限制放开，否则不能选择
        this.pickerOptions.selectableRange = '00:00:00 - 23:59:59';
      }
    },
    eventList() {
      if (this.loaded) this.updateEvents();
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7;
        },
        selectableRange:
          new Date().getHours() + ':' + (new Date().getMinutes() + 1) + ':00' + ' - 23:59:59',
      },
      /* eslint-enable */
      objectFiledsList: [],
      periodicNumber: 0,
      timeoutNumber: 0,
      timeoutUnit: 'd',
      periodicUnit: 'd',
      initialTriggerTime: '',
      periodicUnitOptions: [
        {
          value: 'd',
          label: '天',
        },
        {
          value: 'h',
          label: '小时',
        },
        {
          value: 'm',
          label: '分钟',
        },
        {
          value: 's',
          label: '秒',
        },
      ],
      timeoutUnitOptions: [
        {
          value: 'd',
          label: '天',
        },
        {
          value: 'h',
          label: '小时',
        },
        {
          value: 'm',
          label: '分钟',
        },
      ],
      remark: '',
      loaded: false,
      eventOptions: [],
      // 云函数事件ids
      cloudEventIds: [],
      // 通知事件ids
      notifyEventIds: [],
      eventList: [],
    };
  },
  computed: {
    ...mapGetters({
      businessEntityList: 'notice/getObjectList',
    }),
    disableStartBizType() {
      return !!this.$route.query.objectId;
    },
    objectResourceId() {
      if (this.value.metadata?.trigger?.resource) {
        return (
          this.businessEntityList.find(
            (object) => object.name === this.value.metadata.trigger.resource,
          )?.id || ''
        );
      }
      return '';
    },
    showBusinessEntityList() {
      return this.businessEntityList.map(({ name, display_name }) => {
        return {
          label: display_name ? `${display_name}-${name}` : name,
          value: name,
        };
      });
    },
  },

  async created() {
    await this.getEventOptions();
    if (this.value.metadata?.trigger?.resource) {
      const objId = this.businessEntityList.find(
        (object) => object.name === this.value.metadata.trigger.resource,
      )?.id;
      const { fields } = await this.$request({
        url: this.$api.metaGetObjectFields,
        data: {
          object_id: objId,
        },
      });
      this.objectFiledsList = fields;
    }
    if (this.value.metadata?.trigger?.periodic_value) {
      const cloneVal = cloneDeep(this.value.metadata.trigger.periodic_value);
      this.periodicNumber = +cloneVal.replace(/[^0-9]/gi, '');
      this.periodicUnit = cloneVal.replace(/[0-9]/gi, '');
    }
    if (this.value.metadata?.timeout?.timeout_value) {
      const cloneVal = cloneDeep(this.value.metadata.timeout.timeout_value);
      this.timeoutNumber = +cloneVal.replace(/[^0-9]/gi, '');
      this.timeoutUnit = cloneVal.replace(/[0-9]/gi, '');
    }
    if (this.value.metadata?.trigger?.initial_trigger_time) {
      this.initialTriggerTime = this.value.metadata.trigger.initial_trigger_time * 1000;
    }
    this.loaded = true;
  },
  methods: {
    ...mapMutations('workflow', ['setStartNodeObject']),
    // 添加新建的通知事件到输入框
    addNoticeEventValue(id) {
      if (id) {
        this.eventList.push(['notify', id]);
      }
    },
    // 添加新建的云函数到输入框
    addCloudEventValue(id) {
      if (id) {
        this.eventList.push(['cloud_fun', id]);
      }
    },
    valueUpdate(path, value) {
      this.$emit('update', path, value);
    },
    startBizChange(e) {
      this.valueUpdate('metadata.trigger.resource', e);
      this.setStartNodeObject(e);
      const objId = this.businessEntityList.find((object) => object.name === e)?.id;
      this.$request({
        url: this.$api.metaGetObjectFields,
        data: {
          object_id: objId,
        },
      }).then((data) => {
        this.objectFiledsList = data.fields;
        this.$refs?.conditionalSelectionTree?.resetNodes();
      });
    },
    periodicNumberChange(e) {
      this.loaded && this.valueUpdate('metadata.trigger.periodic_value', e + this.periodicUnit);
    },
    periodicUnitChange(e) {
      this.loaded && this.valueUpdate('metadata.trigger.periodic_value', this.periodicNumber + e);
    },
    timeoutNumberChange(e) {
      this.loaded &&
        this.valueUpdate('metadata.timeout.timeout_value', e ? e + this.timeoutUnit : '');
    },
    timeoutUnitChange(e) {
      this.loaded &&
        this.valueUpdate(
          'metadata.timeout.timeout_value',
          this.timeoutNumber ? this.timeoutNumber + e : '',
        );
    },
    initialTriggerTimeChange(e) {
      const startTime = new Date(e).getTime();
      if (startTime < Date.now()) {
        this.initialTriggerTime = Date.parse(new Date());
        this.valueUpdate('metadata.trigger.initial_trigger_time', Date.parse(new Date()) / 1000);
      } else {
        this.valueUpdate('metadata.trigger.initial_trigger_time', e / 1000);
      }
    },

    // 获取事件选择项
    async getEventOptions() {
      return new Promise((resolve) => {
        this.$request({
          url: this.$api.getProcessActionList,
          data: {
            page: 0,
            size: -1,
          },
          cb: (res) => {
            this.cloudEventIds = [];
            this.notifyEventIds = [];
            const notifyOptions = {
              value: 'notify',
              label: '通知消息',
              children: [],
            };
            const cloudFunOptions = {
              value: 'cloud_fun',
              label: '云函数自定义事件',
              children: [],
            };
            res.list.forEach((item) => {
              if (item.category === 1) {
                this.notifyEventIds.push(item.id);
                if (item.status === 2) {
                  notifyOptions.children.push({
                    value: item.id,
                    label: `通知消息-${item.name}`,
                    status: item.status,
                    disabled: true,
                    prefix: '通知消息-',
                  });
                } else {
                  notifyOptions.children.unshift({
                    value: item.id,
                    label: `通知消息-${item.name}`,
                    status: item.status,
                    disabled: false,
                    prefix: '通知消息-',
                  });
                }
              } else {
                this.cloudEventIds.push(item.id);
                if (
                  item.status === 2 ||
                  (item.keys.length && !item.keys.includes(this.info.process_key))
                ) {
                  cloudFunOptions.children.push({
                    value: item.id,
                    label: `云函数-${item.name}`,
                    status: item.status,
                    disabled: true,
                    prefix: '云函数-',
                  });
                } else {
                  cloudFunOptions.children.unshift({
                    value: item.id,
                    label: `云函数-${item.name}`,
                    status: item.status,
                    disabled: false,
                    prefix: '云函数-',
                  });
                }
              }
            });
            this.eventOptions = [notifyOptions, cloudFunOptions];

            // 更新回显
            this.updateList(this.value.metadata.timeout.events);
            resolve();
          },
        });
      });
    },
    updateEvents() {
      const events = this.eventList.map((i) => i[1]);
      this.valueUpdate('metadata.timeout.events', events);
    },
    // 同时满足节点数据结构将开始结束放在一个列表内与事件配置需要将开始结束分两个列表存放的情况
    updateList(value) {
      this.eventList = value
        .map((i) => {
          if (this.cloudEventIds.includes(i)) {
            // 级联选择器返回的单元数据格式为 [父元素value, 字元素value]
            return ['cloud_fun', i];
          }
          if (this.notifyEventIds.includes(i)) {
            // 级联选择器返回的单元数据格式为 [父元素value, 字元素value]
            return ['notify', i];
          }
          return '';
        })
        .filter((i) => i);
    },
    openCreateCloudEventDialog() {
      this.$refs.createCloudEventDialog.openDiaLog();
    },
    openCreateNotifyEventDialog() {
      this.$refs.creatNotifyEventDialog.openDiaLog();
    },
  },
};
